import { RegularPage, getStaticProps as getProps } from 'layout/page';

export const getStaticProps = getProps;

export default RegularPage;
